// Messages of the market intelligence section. Spanish is the reference;
// English is the fallback for the other locales (same model as the hub).
export const marketSpanishMessages = {
  market: {
    title: "Inteligencia de mercado",
    tabs: {
      label: "Secciones de inteligencia de mercado",
      daily: "Diario",
      weekly: "Semanal",
      // Short on purpose: "Competidores" does not fit a quarter of a 375px
      // phone, and the tab reads the same on every screen.
      competitors: "Competencia",
      opportunities: "Prospectos",
      ideas: "Ideas",
    },
    priority: {
      alta: "Alta",
      media: "Media",
      baja: "Baja",
      label: "Prioridad",
    },
    idea_status: {
      nueva: "Nueva",
      evaluando: "Evaluando",
      en_marcha: "En marcha",
      descartada: "Descartada",
      label: "Estado",
    },
    lines: {
      all: "Todas",
      label: "Línea",
      avante_crm_clinicas: "Avante CRM clínicas",
      agente_licitaciones: "Agente de licitaciones",
      automatizacion_pymes: "Automatización pymes",
      otro: "Otro",
    },
    tracking_status: {
      label: "Seguimiento",
      all: "Todos",
      change: "Cambiar seguimiento",
      vigilar: "Vigilar",
      analizado: "Analizado",
      amenaza_alta: "Amenaza alta",
      descartado: "Descartado",
    },
    opportunity_type: {
      label: "Tipo",
      cliente_potencial: "Cliente potencial",
      licitacion: "Licitación",
      partner: "Partner",
      idea: "Idea",
    },
    opportunity_stage: {
      label: "Etapa",
      change: "Mover a otra etapa",
      nueva: "Nuevo",
      en_contacto: "En contacto",
      propuesta: "Propuesta",
      ganada: "Ganado",
      perdida: "Perdido",
    },
    nav: {
      latest: "Último",
      pick_date: "Elegir fecha",
      previous_report: "Informe anterior",
      next_report: "Informe siguiente",
      previous_week: "Semana anterior",
      next_week: "Semana siguiente",
    },
    daily: {
      heading: "Informe diario",
      what_happens: "Qué pasa",
      why_it_matters: "Por qué importa a Litus",
      idea: "Idea concreta",
      sources: "Fuentes",
      opportunity: "Oportunidad del día",
      items: "%{smart_count} noticia |||| %{smart_count} noticias",
      save_idea: "Guardar como idea",
      idea_saved: "Idea guardada",
      idea_exists: "Guardada como idea",
      view_idea: "ver en Ideas",
      no_report_for: "No hay informe para el %{date}",
      no_report_hint:
        "Cada mañana de los días laborables se publica un informe.",
      go_latest: "Ir al último informe",
      no_reports: "Todavía no hay informes",
      no_reports_hint: "El primer informe diario aparecerá aquí.",
      sector: "Sector",
      product_type: "Tipo de producto",
    },
    weekly: {
      heading: "Digest semanal",
      trends: "Tendencias de la semana",
      top_opportunities: "Mejores oportunidades",
      competitor_moves: "Movimientos de competidores",
      empty_section: "Sin contenido esta semana.",
      no_digests: "Todavía no hay resúmenes semanales",
      no_digests_hint: "Cada viernes se publica un resumen.",
      no_digest_for: "No hay resumen para esa semana",
      go_latest: "Ir al último resumen",
    },
    competitors: {
      heading: "Competencia",
      what_they_do: "Qué hacen",
      pricing: "Precio",
      strengths: "Fortalezas",
      weaknesses: "Debilidades",
      latest_news: "Última novedad: %{date}",
      no_news: "Sin novedades",
      website: "Web",
      timeline: "Novedades",
      source: "Fuente",
      back: "Competencia",
      empty: "No hay competidores en esta línea",
      empty_all: "Todavía no hay competidores",
      empty_hint: "Se irán añadiendo con la investigación.",
      empty_filtered: "Ningún competidor con estos filtros",
      clear_filters: "Quitar filtros",
      not_found: "Este competidor no existe",
      add: "Añadir competidor",
      edit: "Editar",
      edit_title: "Editar competidor",
      location: "Ubicación",
      entry_price: "Precio de entrada",
      value_proposition: "Propuesta de valor",
      channels: "Canales",
      notes: "Notas internas",
      last_reviewed: "Revisado el %{date}",
      never_reviewed: "Sin revisar",
      mark_reviewed: "Marcar revisado hoy",
      created: "Competidor añadido",
      updated: "Competidor actualizado",
      status_updated: "Seguimiento: %{status}",
      error: "No se pudo guardar el competidor. Inténtalo de nuevo.",
      duplicate: "Ya existe un competidor con ese nombre",
      form: {
        name: "Nombre",
        website: "Web",
        line: "Línea",
        location: "Ubicación",
        entry_price: "Precio de entrada",
        pricing: "Precios (detalle)",
        value_proposition: "Propuesta de valor",
        channels: "Canales",
        description: "Qué hacen",
        strengths: "Fortalezas",
        weaknesses: "Debilidades",
        notes: "Notas internas",
        last_reviewed_at: "Última revisión",
        markdown_hint: "Admite listas con «- », **negrita** y enlaces.",
        save: "Guardar",
        cancel: "Cancelar",
        name_required: "El nombre es obligatorio",
        name_too_long: "El nombre es demasiado largo (máx. 120 caracteres)",
        date_invalid: "La fecha no es válida",
      },
      notes_timeline: {
        heading: "Novedades y notas",
        news: "Novedad",
        note: "Nota",
        by: "Nota de %{name}",
        team_note: "Nota del equipo",
        add: "Añadir nota",
        placeholder: "Qué has visto: precio, cliente, movimiento…",
        save: "Guardar nota",
        cancel: "Cancelar",
        saved: "Nota añadida",
        deleted: "Nota eliminada",
        delete: "Eliminar nota",
        delete_confirm: "¿Eliminar?",
        error: "No se pudo guardar la nota. Inténtalo de nuevo.",
        empty: "Sin novedades ni notas todavía",
      },
      note_errors: {
        required: "Escribe la nota",
        too_long: "La nota es demasiado larga (máx. 4000 caracteres)",
      },
    },
    opportunities: {
      heading: "Prospectos",
      new: "Nuevo prospecto",
      edit: "Editar prospecto",
      view: "Vista",
      view_list: "Lista",
      view_board: "Tablero",
      empty_all: "Todavía no hay prospectos",
      empty_hint:
        "Apunta clientes potenciales, licitaciones o partners que salgan de la investigación.",
      empty_column: "Sin prospectos",
      total: "%{smart_count} prospecto |||| %{smart_count} prospectos",
      next_step: "Siguiente paso",
      no_next_step: "Sin siguiente paso",
      overdue: "Vencido",
      due: "Para el %{date}",
      estimated_value: "Valor estimado",
      contact: "Contacto",
      sector: "Sector",
      owner: "Responsable",
      created: "Prospecto creado",
      updated: "Prospecto actualizado",
      moved: "Movido a «%{stage}»",
      deleted: "Prospecto eliminado",
      error: "No se pudo guardar el prospecto. Inténtalo de nuevo.",
      delete: "Eliminar",
      delete_confirm: "¿Eliminar este prospecto? No se puede deshacer.",
      deal_link: "Ver trato",
      linked_deal: "Convertido en trato",
      form: {
        name: "Nombre",
        type: "Tipo",
        stage: "Etapa",
        sector: "Sector",
        contact: "Contacto",
        estimated_value: "Valor estimado (€)",
        next_step: "Siguiente paso",
        next_step_date: "Fecha del siguiente paso",
        notes: "Notas",
        save: "Guardar",
        cancel: "Cancelar",
        name_required: "El nombre es obligatorio",
        name_too_long: "El nombre es demasiado largo (máx. 200 caracteres)",
        value_invalid: "El valor estimado tiene que ser un número",
        date_invalid: "La fecha no es válida",
      },
      convert: {
        action: "Convertir en trato",
        title: "Convertir en trato",
        intro:
          "Se creará un trato en el embudo con estos datos y quedará enlazado al prospecto.",
        submit: "Crear trato",
        done: "Trato creado",
        error: "No se pudo crear el trato. Inténtalo de nuevo.",
      },
    },
    ideas: {
      heading: "Ideas",
      new: "Nueva idea",
      edit: "Editar idea",
      source: "Ver noticia de origen",
      empty_column: "Sin ideas",
      empty: "No hay ideas en «%{status}»",
      empty_all: "Todavía no hay ideas",
      empty_hint: "Crea una o guarda una noticia del informe diario como idea.",
      updated: "Idea actualizada",
      created: "Idea creada",
      deleted: "Idea eliminada",
      error: "No se pudo guardar la idea. Inténtalo de nuevo.",
      change_status: "Cambiar estado",
      change_priority: "Cambiar prioridad",
      delete: "Eliminar",
      delete_confirm: "¿Eliminar esta idea? No se puede deshacer.",
      form: {
        title: "Título",
        description: "Descripción",
        description_hint: "Admite listas con «- », **negrita** y enlaces.",
        sector: "Sector",
        product_type: "Tipo de producto",
        save: "Guardar",
        cancel: "Cancelar",
        title_required: "El título es obligatorio",
        title_too_long: "El título es demasiado largo (máx. 200 caracteres)",
      },
    },
    loading: "Cargando…",
    error: "No se pudo cargar la información. Inténtalo de nuevo.",
  },
};

export const marketEnglishMessages: typeof marketSpanishMessages = {
  market: {
    title: "Market intelligence",
    tabs: {
      label: "Market intelligence sections",
      daily: "Daily",
      weekly: "Weekly",
      competitors: "Competitors",
      opportunities: "Prospects",
      ideas: "Ideas",
    },
    priority: { alta: "High", media: "Medium", baja: "Low", label: "Priority" },
    idea_status: {
      nueva: "New",
      evaluando: "Evaluating",
      en_marcha: "In progress",
      descartada: "Discarded",
      label: "Status",
    },
    lines: {
      all: "All",
      label: "Line",
      avante_crm_clinicas: "Avante CRM clinics",
      agente_licitaciones: "Public tenders agent",
      automatizacion_pymes: "SME automation",
      otro: "Other",
    },
    tracking_status: {
      label: "Tracking",
      all: "All",
      change: "Change tracking",
      vigilar: "Watch",
      analizado: "Analysed",
      amenaza_alta: "High threat",
      descartado: "Dismissed",
    },
    opportunity_type: {
      label: "Type",
      cliente_potencial: "Potential client",
      licitacion: "Public tender",
      partner: "Partner",
      idea: "Idea",
    },
    opportunity_stage: {
      label: "Stage",
      change: "Move to another stage",
      nueva: "New",
      en_contacto: "In contact",
      propuesta: "Proposal",
      ganada: "Won",
      perdida: "Lost",
    },
    nav: {
      latest: "Latest",
      pick_date: "Pick a date",
      previous_report: "Previous report",
      next_report: "Next report",
      previous_week: "Previous week",
      next_week: "Next week",
    },
    daily: {
      heading: "Daily report",
      what_happens: "What happens",
      why_it_matters: "Why it matters to Litus",
      idea: "Concrete idea",
      sources: "Sources",
      opportunity: "Opportunity of the day",
      items: "%{smart_count} item |||| %{smart_count} items",
      save_idea: "Save as idea",
      idea_saved: "Idea saved",
      idea_exists: "Saved as an idea",
      view_idea: "view in Ideas",
      no_report_for: "No report for %{date}",
      no_report_hint: "A new report is published every working-day morning.",
      go_latest: "Go to the latest report",
      no_reports: "No reports yet",
      no_reports_hint: "The first daily report will show up here.",
      sector: "Sector",
      product_type: "Product type",
    },
    weekly: {
      heading: "Weekly digest",
      trends: "Trends of the week",
      top_opportunities: "Top opportunities",
      competitor_moves: "Competitor moves",
      empty_section: "Nothing this week.",
      no_digests: "No weekly digests yet",
      no_digests_hint: "A new digest is published every Friday.",
      no_digest_for: "No digest for that week",
      go_latest: "Go to the latest digest",
    },
    competitors: {
      heading: "Competitors",
      what_they_do: "What they do",
      pricing: "Pricing",
      strengths: "Strengths",
      weaknesses: "Weaknesses",
      latest_news: "Latest news: %{date}",
      no_news: "No news",
      website: "Website",
      timeline: "News",
      source: "Source",
      back: "Competitors",
      empty: "No competitors in this line",
      empty_all: "No competitors yet",
      empty_hint: "They will be added as research goes on.",
      empty_filtered: "No competitors match these filters",
      clear_filters: "Clear filters",
      not_found: "This competitor does not exist",
      add: "Add competitor",
      edit: "Edit",
      edit_title: "Edit competitor",
      location: "Location",
      entry_price: "Entry price",
      value_proposition: "Value proposition",
      channels: "Channels",
      notes: "Internal notes",
      last_reviewed: "Reviewed on %{date}",
      never_reviewed: "Not reviewed",
      mark_reviewed: "Mark reviewed today",
      created: "Competitor added",
      updated: "Competitor updated",
      status_updated: "Tracking: %{status}",
      error: "The competitor could not be saved. Please try again.",
      duplicate: "A competitor with that name already exists",
      form: {
        name: "Name",
        website: "Website",
        line: "Line",
        location: "Location",
        entry_price: "Entry price",
        pricing: "Pricing (details)",
        value_proposition: "Value proposition",
        channels: "Channels",
        description: "What they do",
        strengths: "Strengths",
        weaknesses: "Weaknesses",
        notes: "Internal notes",
        last_reviewed_at: "Last review",
        markdown_hint: "Supports “- ” lists, **bold** and links.",
        save: "Save",
        cancel: "Cancel",
        name_required: "The name is required",
        name_too_long: "The name is too long (max. 120 characters)",
        date_invalid: "The date is not valid",
      },
      notes_timeline: {
        heading: "News and notes",
        news: "News",
        note: "Note",
        by: "Note by %{name}",
        team_note: "Team note",
        add: "Add note",
        placeholder: "What did you see: price, customer, move…",
        save: "Save note",
        cancel: "Cancel",
        saved: "Note added",
        deleted: "Note deleted",
        delete: "Delete note",
        delete_confirm: "Delete?",
        error: "The note could not be saved. Please try again.",
        empty: "No news or notes yet",
      },
      note_errors: {
        required: "Write the note",
        too_long: "The note is too long (max. 4000 characters)",
      },
    },
    opportunities: {
      heading: "Prospects",
      new: "New prospect",
      edit: "Edit prospect",
      view: "View",
      view_list: "List",
      view_board: "Board",
      empty_all: "No prospects yet",
      empty_hint:
        "Track prospects, public tenders or partners found in the research.",
      empty_column: "No prospects",
      total: "%{smart_count} prospect |||| %{smart_count} prospects",
      next_step: "Next step",
      no_next_step: "No next step",
      overdue: "Overdue",
      due: "Due %{date}",
      estimated_value: "Estimated value",
      contact: "Contact",
      sector: "Sector",
      owner: "Owner",
      created: "Prospect created",
      updated: "Prospect updated",
      moved: "Moved to “%{stage}”",
      deleted: "Prospect deleted",
      error: "The prospect could not be saved. Please try again.",
      delete: "Delete",
      delete_confirm: "Delete this prospect? This cannot be undone.",
      deal_link: "View deal",
      linked_deal: "Converted into a deal",
      form: {
        name: "Name",
        type: "Type",
        stage: "Stage",
        sector: "Sector",
        contact: "Contact",
        estimated_value: "Estimated value (€)",
        next_step: "Next step",
        next_step_date: "Next step date",
        notes: "Notes",
        save: "Save",
        cancel: "Cancel",
        name_required: "The name is required",
        name_too_long: "The name is too long (max. 200 characters)",
        value_invalid: "The estimated value must be a number",
        date_invalid: "The date is not valid",
      },
      convert: {
        action: "Convert into deal",
        title: "Convert into deal",
        intro:
          "A deal will be created in the pipeline with these details and linked to the prospect.",
        submit: "Create deal",
        done: "Deal created",
        error: "The deal could not be created. Please try again.",
      },
    },
    ideas: {
      heading: "Ideas",
      new: "New idea",
      edit: "Edit idea",
      source: "See source news",
      empty_column: "No ideas",
      empty: "No ideas in “%{status}”",
      empty_all: "No ideas yet",
      empty_hint: "Create one or save a daily report item as an idea.",
      updated: "Idea updated",
      created: "Idea created",
      deleted: "Idea deleted",
      error: "The idea could not be saved. Please try again.",
      change_status: "Change status",
      change_priority: "Change priority",
      delete: "Delete",
      delete_confirm: "Delete this idea? This cannot be undone.",
      form: {
        title: "Title",
        description: "Description",
        description_hint: "Supports “- ” lists, **bold** and links.",
        sector: "Sector",
        product_type: "Product type",
        save: "Save",
        cancel: "Cancel",
        title_required: "The title is required",
        title_too_long: "The title is too long (max. 200 characters)",
      },
    },
    loading: "Loading…",
    error: "The information could not be loaded. Please try again.",
  },
};
